import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import withAuthorization from '../../Session/withAuthorization';
import {withRouter} from 'react-router-dom';
import {db} from '../../../firebase'
import {Form, FormGroup, Input, Label, Button} from 'reactstrap';
import * as companies from '../../../constants/companies'
import Spinner from '../../Spinner';
import { toast } from 'react-toastify';

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
  });

const INITIAL_STATE = {
    alias: '',
    error: null,
    isLoading: true,
    company: companies.UTENOS_PREKYBA,
    telephone: '',
    isModerator:false,
    userId: ''
  };

class EditUser extends Component {
    constructor(props) {
      super(props);

      this.state = {...INITIAL_STATE};
    }

    componentDidMount(){

        var userId  = this.props.match.params.userId;

        db.onceGetUser(userId).then((usersSnapshot)=>{
                let user = usersSnapshot.val();
                this.setState({
                    alias: user.alias,
                    company: user.company,
                    telephone: user.telephone,
                    isModerator: user.customClaims.isModerator,
                    userId: userId,
                    isLoading:false
                });
        })
    }
    
    onSubmit=(event)=>{
        this.setState(this.setState(updateByPropertyName('isLoading', true)));
        var {userId, alias, company, telephone, isModerator } = this.state;

        db.doUpdateUser(userId, alias, company, telephone, isModerator).then(()=>{
            this.setState(this.setState(updateByPropertyName('isLoading', false)));
            toast.success("Vartotojas atnaujintas",{
                position: toast.POSITION.BOTTOM_RIGHT
              });
        });

        event.preventDefault();
    }

    render(){

        let {alias, isLoading, company, telephone, isModerator } = this.state;
        const isInvalid = (alias === '');

        if(isLoading){
            return <Spinner></Spinner>
        }
        else{
            return(
                <Form onSubmit={this.onSubmit}>
                <FormGroup>
                  <Label>Slapyvardis</Label>
                  <Input
                    value={alias}
                    onChange={event => this.setState(updateByPropertyName('alias', event.target.value))}
                    type="text"
                    placeholder="Būtinas laukas"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Telefonas</Label>
                  <Input
                    value={telephone}
                    onChange={event => this.setState(updateByPropertyName('telephone', event.target.value))}
                    type="text"
                  />
                </FormGroup>

                <FormGroup>  
                  <Label>Įmonė</Label>
                    <Input
                    value={company}
                    onChange={event => this.setState(updateByPropertyName('company', event.target.value))}
                    type="select"
                  >
        
                 {Object.keys(companies).map(key =>{
                        return <option key={key}>{companies[key]}</option>
                  })}
        
                  </Input>
                </FormGroup>
        
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox"
                          onChange={event => this.setState(updateByPropertyName('isModerator', event.target.checked))}
                          checked={isModerator}
                    />{' '}
                    Yra moderatorius
                  </Label>
                </FormGroup>  
        
              <div className="create-complain-btn">
                <FormGroup>
                <Button disabled={isInvalid} type="submit">
                  Išsaugoti
                </Button>
                </FormGroup>
              </div>  
              </Form>
            )    
        }
    }
}

const authCondition = (authUser, token) => {
    return !!authUser && token.claims.isAdmin;
};

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer,  
)(EditUser);


// WEBPACK FOOTER //
// ./src/components/Users/UserForm/index.js